import modalCodes from '@store/modules/ui/shared/modal/modalCodes';
import { getShellConfig } from '@src/config/shell/config';
import { featureFlagService } from '@superbet-group/web.lib.flags';

export function useShowSuperBonusV2WelcomeModal(
    setModal: (modal: { code: string; data?: any }) => void,
) {
    async function showSuperBonusV2WelcomeModal() {
        const isSuperBonusV2WelcomeModalShown = localStorage.getItem('isSuperBonusV2WelcomeModalShown');
        const isSuperbonusV2WelcomingModalEnabled = await featureFlagService.getFeatureValue('bex.generosity.superbonus-v2-welcoming-modal', false);
        if (isSuperbonusV2WelcomingModalEnabled && !isSuperBonusV2WelcomeModalShown) {
            const minimumOdd = getShellConfig().remoteConfig.superBonus.superBonusMinCoef;
            const numberOfSelections = getShellConfig().remoteConfig.superBonus.superBonusMinSelections;
            setModal({
                code: modalCodes.SuperBonusV2WelcomeModal,
                data: {
                    minimumOdd,
                    numberOfSelections,
                },
            });
            localStorage.setItem('isSuperBonusV2WelcomeModalShown', 'true');
        }
    }

    return {
        showSuperBonusV2WelcomeModal,
    };
}
